"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RewardDailyXpBodyToJSON = exports.RewardDailyXpBodyFromJSONTyped = exports.RewardDailyXpBodyFromJSON = void 0;
function RewardDailyXpBodyFromJSON(json) {
    return RewardDailyXpBodyFromJSONTyped(json, false);
}
exports.RewardDailyXpBodyFromJSON = RewardDailyXpBodyFromJSON;
function RewardDailyXpBodyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'discordMemberId': json['discordMemberId'],
    };
}
exports.RewardDailyXpBodyFromJSONTyped = RewardDailyXpBodyFromJSONTyped;
function RewardDailyXpBodyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'discordMemberId': value.discordMemberId,
    };
}
exports.RewardDailyXpBodyToJSON = RewardDailyXpBodyToJSON;
